// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.grid[data-v-2de7b714] {\n    display: flex;\n    justify-content: center;\n    flex-wrap: wrap;\n    padding-top: 50px;\n}\n  ", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
